<button
  [id]="idDropdown + 'Button'"
  class="flex text-sm bg-gray-800 rounded-full md:me-0 focus:ring-4 focus:ring-gray-300 dark:focus:ring-gray-600"
  type="button"
>
  <span class="sr-only">Open user menu</span>
  <img
    class="w-8 h-8 rounded-full"
    [src]="(imgAvatar === '' ? 'assets/img/avatar-default.svg' : imgAvatar) | safe"
    alt="user photo"
  />
</button>

<!-- Dropdown menu -->
<div
  [id]="idDropdown"
  class="z-30 hidden bg-white divide-gray-100 rounded-lg shadow dark:bg-gray-700 dark:divide-gray-600"
>
  <div class="px-4 py-3 text-sm text-gray-900 dark:text-white font-semibold border-b border-gray-200">
    <div>{{ name | translate }}</div>
    <div class="font-normal truncate">
      <span>{{ email | translate }}</span>
    </div>
  </div>
  <ul class="py-2 text-sm text-gray-700 dark:text-gray-200" [attr.aria-labelledby]="idDropdown + 'Button'">
    <li *ngFor="let item of items">
      <button
        (click)="onClickAction(item.action)"
        class="block px-4 py-2 hover:bg-gray-100 dark:hover:bg-gray-600 dark:hover:text-white w-full text-left"
      >
        {{ item.title | translate }}
      </button>
    </li>
  </ul>
</div>
